import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=582f1575&scoped=true"
import script from "./pagination.vue?vue&type=script&lang=js"
export * from "./pagination.vue?vue&type=script&lang=js"
import style0 from "./pagination.vue?vue&type=style&index=0&id=582f1575&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582f1575",
  null
  
)

export default component.exports